import type { LocalizedText, ReportStats } from './types';

// Formatting for the real reports (#823): `null` is always the dash — unknown is
// never printed as 0. Copy stays in the locale files; these only shape numbers.

const DASH = '—';

export function usd(value: number | null | undefined): string {
  if (value === null || value === undefined) return DASH;
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function pct(value: number | null | undefined): string {
  if (value === null || value === undefined) return DASH;
  return `${value.toLocaleString('en-US', { maximumFractionDigits: 1 })}%`;
}

export function num(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined) return DASH;
  return value.toLocaleString('en-US', { maximumFractionDigits: digits });
}

/**
 * An airline price (commercial-contract M3): the amount, or `unavailable` («No disponible»)
 * when the BFF had no price card for it (`priced: false`); a null amount on a priced
 * payload is merely unknown — the dash, as `usd`.
 */
export function priceText(value: number | null | undefined, priced: boolean, unavailable: string): string {
  if ((value === null || value === undefined) && !priced) return unavailable;
  return usd(value);
}

/** `p50 / p95` of a sample with its unit; the dash when there is no sample. */
export function p50p95(stats: ReportStats, unit: string): string {
  if (stats.count === 0) return DASH;
  return `${num(stats.p50)} / ${num(stats.p95)} ${unit}`;
}

/** The definition text in the console's language (Spanish first; English otherwise). */
export function localized(text: LocalizedText, lang: string): string {
  return lang.toLowerCase().startsWith('es') ? text.es : text.en;
}
